import { Row } from 'react-table';
import tableStyles from '../Table.module.scss';
import { Fragment } from 'react';

interface TableRowProps<T extends Record<string, unknown>> {
    row: Row<T>;
}
const TableRow = <T extends Record<string, unknown>>({ row }: TableRowProps<T>): JSX.Element => {
    const isTotalRow = (row.original as { isTotalRow?: boolean }).isTotalRow;
    const rowProps = row.getRowProps();
    const className = [tableStyles._tableBodyRow, isTotalRow ? tableStyles._tableBodyRowTotal : '', rowProps.className ?? '']
        .filter(Boolean)
        .join(' ');

    return (
        <tr {...rowProps} className={className}>
            {row.cells.map((cell, index) => {
                return <Fragment key={index}>{cell.render('Cell')}</Fragment>;
            })}
        </tr>
    );
};

export default TableRow;
